import { MUIBox, MUITypography } from "@cobee/cobee-ui";
import styles from "./styles";

export default function DetailRow({
  label,
  value,
  color,
}: {
  label: string;
  value: string;
  color?: string;
}): JSX.Element {
  const { row, labelStyle } = styles;

  return (
    <MUIBox sx={row}>
      <MUITypography
        variant="body1"
        sx={labelStyle}
      >{`${label}:`}</MUITypography>
      <MUITypography variant={color ? "body1" : "body2"} color={color}>
        {value}
      </MUITypography>
    </MUIBox>
  );
}
